import styled from "styled-components";

export const ContainerUserInfo = styled("section")`
  min-height: 300px;
  background-color: #fff;
  box-shadow: 0 12px 12px 0 hsl(0deg 0% 71% / 10%);
  border-radius: var(--border-radius-1);
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: repeat(4, 170px);
  @media screen and (max-width: 992px) {
    grid-template-rows: repeat(4, auto);
    grid-template-columns: auto auto;
  }
`;

export const ChartWrapper = styled.div`
  .div-container-inf-profile {
    max-width: 500px;
  }
`;

export const HeaderSectionInfo = styled.h5`
  color: var(--blue-color-dark);
`;

export const HeaderUserInfo = styled.p`
  color: var(--blue-color-dark);
`;

export const UserInfo = styled("p")`
  color: var(--primary-color);
  letter-spacing: -0.5px;
  word-wrap: break-word;
`;

export const UserContainerInfo = styled.div`
  padding: 25px 15px;
  vertical-align: bottom;
  border: 1px solid var(--blue-color-dark);
  border-right: 1px solid var(--blue-color-dark);
  &:first-child {
    border-top-right-radius: inherit;
  }
  &:last-child {
    border-bottom-left-radius: inherit;
  }
  &:nth-child(4) {
    border-top-left-radius: inherit;
  }
  &:nth-child(5) {
    border-bottom-right-radius: inherit;
  }
  @media screen and (max-width: 992px) {
    &:nth-child(4),
    &:nth-child(5) {
      border-top-left-radius: initial;
      border-bottom-right-radius: initial;
    }
    &:nth-child(2) {
      border-top-left-radius: inherit;
    }
    &:nth-child(7) {
      border-bottom-right-radius: inherit;
    }
  }
`;
